import {Injectable} from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpResponse, HttpHeaders
} from '@angular/common/http';
import {Location} from '@angular/common';
import {throwError, Observable, BehaviorSubject, of} from 'rxjs';
import {catchError, filter, take, switchMap, finalize, delay, tap} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {secureStorage} from "../shared/functions/secure-storage";
import {LoaderService} from "./loader.service";
import {AuthService} from "./auth.service";
import {GetLanguage, HandleResponseError} from "../shared/functions/shared-functions";
import {ActivatedRoute} from "@angular/router";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private AUTH_HEADER = 'Authorization';
  private token = secureStorage.getItem('token');


  constructor(
    private loaderService: LoaderService,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private authService: AuthService,
    private toastr: ToastrService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loaderService.show();
    // if (!req.headers.has('Content-Type')) {
    //   req = req.clone({
    //     headers: req.headers.set('Content-Type', 'application/json')
    //   });
    // }

    req = this.addAuthenticationToken(req);

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.loaderService.hide();
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this.loaderService.hide();
        console.log('error', error)
        if (error && (error.status === 401 || error.status === 403)) {
          setTimeout(() => {
            this.authService.logOut();
          }, 2000);
        }
        if (error && (error.status === 404)) {
          setTimeout(() => {
            // this.location.back();
          }, 2000);
          this.toastr.error(HandleResponseError(error));

        }
        return throwError(error);
      })
    );
  }

  private addAuthenticationToken(request: HttpRequest<any>): HttpRequest<any> {
    // If we do not have a token yet then we should not set the header.
    // Here we could first retrieve the token from where we store it.
    this.token = secureStorage.getItem('token');
    if (!this.token) {
      return request.clone({
        headers: request.headers.delete('Content-Type')
      });
      // return request;
    }
    // If you are calling an outside domain then do not add the token.
    if (request.url.includes('login') ||
      request.url.includes('ipify') || request.url.includes('ipinfo') ||
      (request.url.includes('forget-password') && request.url.includes('reset-password'))) {
      return request;
    }

    if (request.url.includes('streamVideo')) {
      return request.clone({
        responseType: 'blob' as 'json',
      });
    }

    if (request.url.includes('export')) {
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.token}`,
          language: GetLanguage(),
        },
        responseType: 'blob' as 'json'
      });
    }

    return request.clone({
      // headers: request.headers.set(this.AUTH_HEADER, this.token)
      setHeaders: {
        Authorization: `Bearer ${this.token}`,
        language: GetLanguage(),
      },
    });
  }
}
